module.exports = {"menu":[{"name":"REPORTS.PROPERTY_BALANCE.GENERAL.SINGULAR","link":"/property-balance","sub":[],"icon":"fa-tasks","permission":null,"entity":null},{"name":"GENERAL.CITATION","link":"/citation","sub":[],"icon":"fa-ballot-check","permission":null,"entity":null}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/menu.json
// module id = ./src/assets/menu/menu.json
// module chunks = main